import { render, staticRenderFns } from "./ClientesLista.vue?vue&type=template&id=54646768&scoped=true&"
import script from "./ClientesLista.vue?vue&type=script&lang=js&"
export * from "./ClientesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54646768",
  null
  
)

export default component.exports